import { jsxs, jsx } from "react/jsx-runtime";
const IconSpacePrivateSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M11.029 2.253a1.99 1.99 0 0 1 1.943 0l8.515 4.765c.482.27.655.884.387 1.37a.996.996 0 0 1-1.36.391L20 8.491v11.494h1c.552 0 1 .451 1 1.007 0 .556-.448 1.008-1 1.008H3c-.552 0-1-.452-1-1.008s.448-1.007 1-1.007h1V8.491l-.513.288a.997.997 0 0 1-1.36-.391 1.012 1.012 0 0 1 .388-1.37l8.514-4.765Z" })
    ]
  }
);
export {
  IconSpacePrivateSvg
};
